import React, { useState } from 'react';
import { Calendar, MapPin, Clock, Users, MessageSquare, Award, ArrowRight } from 'lucide-react';
import { Button } from '../components/UI/Button';
import { Link } from 'react-router-dom';
export const WarriEvent2025 = () => {
  const [activeTab, setActiveTab] = useState('details');
  const eventQuotes = ['Network and Grow', "Don't only use bridges, build them.", "Opportunities don't just knock—they're introduced through people.", 'Give, and Give; it comes back to you in greater measure.'];
  return <div className="pt-20 bg-white" data-id="element-5045" data-mp="14o3kw228irj9">
      {/* Hero Section */}
      <section className="relative py-16 border-b border-gray-300" data-id="element-5046" data-mp="zw3p8lt76ksh">
        <div className="absolute inset-0 z-0" data-id="element-5047" data-mp="zu91z0ugegl8">
          <div className="w-full h-full bg-gray-200 border-2 border-dashed border-gray-400" data-id="element-5048" data-mp="vvjshjcjdj6v"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-5049" data-mp="1sdoerfzxf97b">
          <div className="max-w-3xl mx-auto text-center" data-id="element-5050" data-mp="1nly1p29lu7c7">
            <div className="inline-block bg-white border border-gray-300 px-4 py-1 rounded-md text-sm font-bold mb-6" data-id="element-5051" data-mp="1nkd8bfz10ufx">
              UPCOMING EVENT
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6" data-id="element-5052" data-mp="73445te9gx5e">
              Networking Salon: Warri Edition 2025
            </h1>
            <p className="text-xl text-gray-600 mb-8" data-id="element-5053" data-mp="3oh9juyniyeqi">
              Connect with ambitious professionals in Warri and build meaningful
              relationships that unlock new opportunities.
            </p>
            <div className="flex flex-wrap justify-center gap-4" data-id="element-5054" data-mp="3fl0i3dc2r417">
              <Button className="border-2 border-gray-800" data-id="element-5055" data-mp="3kjbu9upudqml">Register Now</Button>
              <Button variant="outline" className="border-2 border-gray-400" data-id="element-5056" data-mp="35ljgp83uvcb1">
                Learn More
              </Button>
            </div>
          </div>
        </div>
      </section>
      {/* Event Details Section */}
      <section className="py-12 border-b border-gray-300" data-id="element-5057" data-mp="13tmw78zpms44">
        <div className="container mx-auto px-4" data-id="element-5058" data-mp="18spw6f0u2858">
          <div className="max-w-4xl mx-auto" data-id="element-5059" data-mp="18q3swrkz6est">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-5060" data-mp="17bkcunu1ppgr">
              <div className="border-2 border-gray-300 rounded-lg p-6 flex flex-col items-center text-center" data-id="element-5061" data-mp="12bxw44f0dr37">
                <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mb-4" data-id="element-5062" data-mp="xcl8hhgbcfzk">
                  <Calendar size={24} className="text-gray-700" data-id="element-5063" data-mp="tc1bcdvqpcdf" />
                </div>
                <h3 className="text-lg font-bold text-gray-800 mb-2" data-id="element-5064" data-mp="1q21yy9kdhmt5">Date</h3>
                <p className="text-gray-600" data-id="element-5065" data-mp="1l2flbz0mu4jt">August 30, 2025</p>
              </div>
              <div className="border-2 border-gray-300 rounded-lg p-6 flex flex-col items-center text-center" data-id="element-5066" data-mp="1l4ijx7fup605">
                <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mb-4" data-id="element-5067" data-mp="1ca3y0m0tex82">
                  <MapPin size={24} className="text-gray-700" data-id="element-5068" data-mp="28sjrad1amgdz" />
                </div>
                <h3 className="text-lg font-bold text-gray-800 mb-2" data-id="element-5069" data-mp="241jtl5kcnuaf">Venue</h3>
                <p className="text-gray-600" data-id="element-5070" data-mp="23zgtfsphgkrz">Deluxe á la Carte Restaurant</p>
                <p className="text-gray-600" data-id="element-5071" data-mp="3mpmgkvcqn2hq">Warri, Nigeria</p>
              </div>
              <div className="border-2 border-gray-300 rounded-lg p-6 flex flex-col items-center text-center" data-id="element-5072" data-mp="3rnxnoybneyw9">
                <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mb-4" data-id="element-5073" data-mp="3vn6hu4aloysc">
                  <Clock size={24} className="text-gray-700" data-id="element-5074" data-mp="4gc3j4qvxxtb" />
                </div>
                <h3 className="text-lg font-bold text-gray-800 mb-2" data-id="element-5075" data-mp="9h9iz9kigdr4">Time</h3>
                <p className="text-gray-600" data-id="element-5076" data-mp="efbe4sv7o3iy">4:00 PM - 7:00 PM</p>
              </div>
            </div>
            <div className="border-2 border-gray-300 rounded-lg overflow-hidden mb-8" data-id="element-5077" data-mp="j8mc04i1p9yq">
              <div className="flex border-b border-gray-300" data-id="element-5078" data-mp="n7v3t3tiyxrn">
                <button className={`px-6 py-3 font-medium ${activeTab === 'details' ? 'bg-gray-200 border-b-2 border-gray-800' : 'bg-white'}`} onClick={() => setActiveTab('details')} data-id="element-5079" data-mp="s8139661doka">
                  Event Details
                </button>
                <button className={`px-6 py-3 font-medium ${activeTab === 'agenda' ? 'bg-gray-200 border-b-2 border-gray-800' : 'bg-white'}`} onClick={() => setActiveTab('agenda')} data-id="element-5080" data-mp="jjbye6ntua9n">
                  Agenda
                </button>
                <button className={`px-6 py-3 font-medium ${activeTab === 'speakers' ? 'bg-gray-200 border-b-2 border-gray-800' : 'bg-white'}`} onClick={() => setActiveTab('speakers')} data-id="element-5081" data-mp="tc9i2g4k259u">
                  Speakers
                </button>
              </div>
              <div className="p-6" data-id="element-5082" data-mp="3rslrqa7wewtc">
                {activeTab === 'details' && <div data-id="element-5083" data-mp="ajp5yad2sesq">
                    <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-5084" data-mp="ajywq05y2pzh">
                      About This Event
                    </h3>
                    <p className="text-gray-600 mb-4" data-id="element-5085" data-mp="5jausjg6goqh">
                      Join us for an evening of meaningful connections,
                      inspiring conversations, and opportunities in Warri. The
                      Networking Salon brings together ambitious professionals,
                      entrepreneurs, and changemakers to build relationships
                      that matter.
                    </p>
                    <p className="text-gray-600 mb-4" data-id="element-5086" data-mp="1tg0ju0aepcll">
                      This special edition will focus on creating strategic
                      connections among Warri's growing professional community,
                      with structured networking activities, curated
                      discussions, and opportunities to share ideas.
                    </p>
                    <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-5087" data-mp="2c8cx3i2llyai">
                      <div className="border border-gray-300 rounded-lg p-4 flex items-start" data-id="element-5088" data-mp="1ygok7ckiz5sh">
                        <Users size={20} className="text-gray-700 mr-3 mt-1 flex-shrink-0" data-id="element-5089" data-mp="22i02sy4zeqr6" />
                        <div data-id="element-5090" data-mp="2q7kxufeetegt">
                          <h4 className="font-bold text-gray-800 mb-1" data-id="element-5091" data-mp="2q7cimgutdx2g">
                            Who Should Attend
                          </h4>
                          <p className="text-gray-600" data-id="element-5092" data-mp="34vuqc2fbv2iy">
                            Professionals, entrepreneurs, creatives, and
                            change-makers ages 18-45
                          </p>
                        </div>
                      </div>
                      <div className="border border-gray-300 rounded-lg p-4 flex items-start" data-id="element-5093" data-mp="2vwhdr0vwpxu0">
                        <Award size={20} className="text-gray-700 mr-3 mt-1 flex-shrink-0" data-id="element-5094" data-mp="2qxo2zg808kxj" />
                        <div data-id="element-5095" data-mp="2lyl46dimbay0">
                          <h4 className="font-bold text-gray-800 mb-1" data-id="element-5096" data-mp="2h60cbhj9v7x4">
                            What You'll Gain
                          </h4>
                          <p className="text-gray-600" data-id="element-5097" data-mp="2d4ojl353q6kp">
                            Strategic connections, visibility, and access to
                            opportunities
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>}
                {activeTab === 'agenda' && <div data-id="element-5098" data-mp="1o2zblduhvho4">
                    <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-5099" data-mp="1o3h542prvhsc">
                      Event Agenda
                    </h3>
                    <div className="space-y-6" data-id="element-5100" data-mp="1t0haebessgie">
                      <div className="border-l-2 border-gray-300 pl-4 ml-4" data-id="element-5101" data-mp="1y1er0jk5t2hs">
                        <div className="flex items-center mb-2" data-id="element-5102" data-mp="1xzapu9dnahl7">
                          <div className="w-8 h-8 bg-gray-200 border border-gray-300 rounded-full flex items-center justify-center -ml-8 mr-2" data-id="element-5103" data-mp="22yx5sqkuybxp">
                            <span className="text-gray-700 font-bold" data-id="element-5104" data-mp="1abkg47jeho06">1</span>
                          </div>
                          <h4 className="font-bold text-gray-800" data-id="element-5105" data-mp="1faxe9ofq2hi2">
                            4:00 PM - 4:30 PM: Registration & Welcome
                          </h4>
                        </div>
                        <p className="text-gray-600 ml-2" data-id="element-5106" data-mp="mm88vd7mvq0i">
                          Check-in, receive your name tag, and enjoy welcome
                          refreshments
                        </p>
                      </div>
                      <div className="border-l-2 border-gray-300 pl-4 ml-4" data-id="element-5107" data-mp="25skti3wi9dn9">
                        <div className="flex items-center mb-2" data-id="element-5108" data-mp="21qg1tapmar39">
                          <div className="w-8 h-8 bg-gray-200 border border-gray-300 rounded-full flex items-center justify-center -ml-8 mr-2" data-id="element-5109" data-mp="21s0t8rgmxtww">
                            <span className="text-gray-700 font-bold" data-id="element-5110" data-mp="2aqcudnf4oa3l">2</span>
                          </div>
                          <h4 className="font-bold text-gray-800" data-id="element-5111" data-mp="2opc9o4gr3cn3">
                            4:30 PM - 5:00 PM: Keynote Session
                          </h4>
                        </div>
                        <p className="text-gray-600 ml-2" data-id="element-5112" data-mp="2yggon46fexhx">
                          Opening remarks and keynote presentation on building
                          powerful networks
                        </p>
                      </div>
                      <div className="border-l-2 border-gray-300 pl-4 ml-4" data-id="element-5113" data-mp="38emolg8o9tk5">
                        <div className="flex items-center mb-2" data-id="element-5114" data-mp="33gl4crzifo73">
                          <div className="w-8 h-8 bg-gray-200 border border-gray-300 rounded-full flex items-center justify-center -ml-8 mr-2" data-id="element-5115" data-mp="3n1d1levrdalk">
                            <span className="text-gray-700 font-bold" data-id="element-5116" data-mp="3r25a25wt3bgs">3</span>
                          </div>
                          <h4 className="font-bold text-gray-800" data-id="element-5117" data-mp="3d2nsoblub0hg">
                            5:00 PM - 6:00 PM: Structured Networking
                          </h4>
                        </div>
                        <p className="text-gray-600 ml-2" data-id="element-5118" data-mp="33bt3ozh7lmsb">
                          Guided networking activities designed to create
                          meaningful connections
                        </p>
                      </div>
                      <div className="border-l-2 border-gray-300 pl-4 ml-4" data-id="element-5119" data-mp="2zb9840caar8a">
                        <div className="flex items-center mb-2" data-id="element-5120" data-mp="2z9ei47m5o8xc">
                          <div className="w-8 h-8 bg-gray-200 border border-gray-300 rounded-full flex items-center justify-center -ml-8 mr-2" data-id="element-5121" data-mp="2kfjh1ns8rnwp">
                            <span className="text-gray-700 font-bold" data-id="element-5122" data-mp="m94j5yg7t7q8">4</span>
                          </div>
                          <h4 className="font-bold text-gray-800" data-id="element-5123" data-mp="r7xzrzqsteum">
                            6:00 PM - 6:45 PM: Panel Discussion
                          </h4>
                        </div>
                        <p className="text-gray-600 ml-2" data-id="element-5124" data-mp="ha1rdfp8wy07">
                          Industry leaders share insights on opportunities in
                          Warri and beyond
                        </p>
                      </div>
                      <div className="border-l-2 border-gray-300 pl-4 ml-4" data-id="element-5125" data-mp="19xns8g739ojd">
                        <div className="flex items-center mb-2" data-id="element-5126" data-mp="va2t0xdc49gq">
                          <div className="w-8 h-8 bg-gray-200 border border-gray-300 rounded-full flex items-center justify-center -ml-8 mr-2" data-id="element-5127" data-mp="v7qaahzr5v2m">
                            <span className="text-gray-700 font-bold" data-id="element-5128" data-mp="1ny8b1cd07kcv">5</span>
                          </div>
                          <h4 className="font-bold text-gray-800" data-id="element-5129" data-mp="1sq8hlnnkxbif">
                            6:45 PM - 7:00 PM: Closing & Next Steps
                          </h4>
                        </div>
                        <p className="text-gray-600 ml-2" data-id="element-5130" data-mp="38hanua8jcy27">
                          Wrap-up, next steps, and information about future
                          events
                        </p>
                      </div>
                    </div>
                  </div>}
                {activeTab === 'speakers' && <div data-id="element-5131" data-mp="2ufydqfg23qo8">
                    <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-5132" data-mp="2uh9ox0bu00pd">
                      Featured Speakers
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-5133" data-mp="33hg1mjzpgwnh">
                      <div className="flex items-center border border-gray-300 rounded-lg p-4" data-id="element-5134" data-mp="33fbl92kme56b">
                        <div className="w-20 h-20 bg-gray-200 border-2 border-dashed border-gray-400 rounded-full mr-4 flex-shrink-0" data-id="element-5135" data-mp="2zhxfjkw5efj2"></div>
                        <div data-id="element-5136" data-mp="eq523zg87sa1">
                          <h4 className="font-bold text-gray-800" data-id="element-5137" data-mp="eotx5wb1oehc">
                            Andrew Igbineweka
                          </h4>
                          <p className="text-gray-600" data-id="element-5138" data-mp="37mgfwpn46ff1">
                            Founder, The Networking Salon
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center border border-gray-300 rounded-lg p-4" data-id="element-5139" data-mp="3hgf8awxdykts">
                        <div className="w-20 h-20 bg-gray-200 border-2 border-dashed border-gray-400 rounded-full mr-4 flex-shrink-0" data-id="element-5140" data-mp="3lhiqvr6tiuyp"></div>
                        <div data-id="element-5141" data-mp="2trw0eii90a28">
                          <h4 className="font-bold text-gray-800" data-id="element-5142" data-mp="2tsxfcy2dxgp8">
                            Local Lead
                          </h4>
                          <p className="text-gray-600" data-id="element-5143" data-mp="32kzg6xgd8z01">Warri City Ambassador</p>
                        </div>
                      </div>
                      <div className="flex items-center border border-gray-300 rounded-lg p-4" data-id="element-5144" data-mp="2621tsioivhqf">
                        <div className="w-20 h-20 bg-gray-200 border-2 border-dashed border-gray-400 rounded-full mr-4 flex-shrink-0" data-id="element-5145" data-mp="2a3n0fmagqzs6"></div>
                        <div data-id="element-5146" data-mp="22j2xsn651bq9">
                          <h4 className="font-bold text-gray-800" data-id="element-5147" data-mp="1xmcabes07dut">
                            Guest Speaker
                          </h4>
                          <p className="text-gray-600" data-id="element-5148" data-mp="1tj62w3t5ngmr">Industry Expert</p>
                        </div>
                      </div>
                      <div className="flex items-center border border-gray-300 rounded-lg p-4" data-id="element-5149" data-mp="1oniis2tj5do4">
                        <div className="w-20 h-20 bg-gray-200 border-2 border-dashed border-gray-400 rounded-full mr-4 flex-shrink-0" data-id="element-5150" data-mp="1joe8f8uvd9w7"></div>
                        <div data-id="element-5151" data-mp="19w03y8cepp6c">
                          <h4 className="font-bold text-gray-800" data-id="element-5152" data-mp="19xb47y6n8esp">
                            Panel Moderator
                          </h4>
                          <p className="text-gray-600" data-id="element-5153" data-mp="10vtt6u83f3av">Community Leader</p>
                        </div>
                      </div>
                    </div>
                  </div>}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Event Highlights */}
      <section className="py-12 border-b border-gray-300" data-id="element-5154" data-mp="2w1ccz1pietuo">
        <div className="container mx-auto px-4" data-id="element-5155" data-mp="30wrpnqbs6jpi">
          <h2 className="text-2xl font-bold text-center text-gray-800 mb-8" data-id="element-5156" data-mp="2m96o40uk0sjp">
            Event Highlights
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-5157" data-mp="2r7q8hwti1w9y">
            <div className="relative aspect-[4/3] border-2 border-dashed border-gray-400 rounded-lg overflow-hidden" data-id="element-5158" data-mp="2d8qletlmxpfw">
              <div className="absolute inset-0 bg-gray-100 flex items-center justify-center" data-id="element-5159" data-mp="2hac6v3c8jc1p">
                <div className="w-16 h-16 border-2 border-gray-400 rounded-full flex items-center justify-center" data-id="element-5160" data-mp="23auao2wm0wib">
                  <MessageSquare size={32} className="text-gray-500" data-id="element-5161" data-mp="28agoadgcoern" />
                </div>
              </div>
            </div>
            <div data-id="element-5162" data-mp="1jqzncit5fx8">
              <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-5163" data-mp="1h4ufjje3ci6">
                Inspiring Conversations
              </h3>
              <div className="space-y-4" data-id="element-5164" data-mp="1qzjuh39pfzam">
                {eventQuotes.map((quote, index) => <div key={index} className="border-l-2 border-gray-400 pl-4" data-id="element-5165" data-mp="1m107czjdkhgo" data-mpi={index}>
                    <p className="text-gray-700 font-medium" data-id="element-5166" data-mp="1lyvu3qzl663q">{quote}</p>
                  </div>)}
              </div>
              <div className="mt-6" data-id="element-5167" data-mp="20rpo0hfluorx">
                <p className="text-gray-600" data-id="element-5168" data-mp="1vywe7f5a4q8z">
                  Join us at Deluxe á la Carte Restaurant in Warri for an
                  evening of meaningful networking and inspiration. Connect with
                  like-minded professionals and discover new opportunities.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Registration Section */}
      <section className="py-12 border-b border-gray-300 bg-gray-50" data-id="element-5169" data-mp="2eqp6t8gfs9g6">
        <div className="container mx-auto px-4" data-id="element-5170" data-mp="pa7pbwcvsfc9">
          <div className="max-w-3xl mx-auto text-center" data-id="element-5171" data-mp="pazmhbm4ml4n">
            <h2 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-5172" data-mp="kcekb6nbdrdk">
              Secure Your Spot
            </h2>
            <p className="text-gray-600 mb-8" data-id="element-5173" data-mp="1a0trdw65bmz5">
              Limited seats available. Register now to join The Networking Salon
              Warri Edition.
            </p>
            <div className="border-2 border-gray-300 rounded-lg p-6 bg-white mb-8" data-id="element-5174" data-mp="1izxc14kyoafr">
              <div className="flex justify-center mb-6" data-id="element-5175" data-mp="1nzjp9e0shqok">
                <div className="w-16 h-16 border-2 border-gray-400 rounded-full flex items-center justify-center" data-id="element-5176" data-mp="1o14j11fa55ld">
                  <Award size={32} className="text-gray-700" data-id="element-5177" data-mp="1swjwhs9dkzh9" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-5178" data-mp="1wy52ctnhsdhy">
                Event Registration
              </h3>
              <div className="text-center mb-6" data-id="element-5179" data-mp="26prnbhpmtqxw">
                <p className="text-3xl font-bold text-gray-800" data-id="element-5180" data-mp="26pj99mhrwfl4">₦5,000</p>
                <p className="text-gray-600" data-id="element-5181" data-mp="2bpx9iid4ul8l">per person</p>
              </div>
              <ul className="space-y-3 mb-8 text-left max-w-md mx-auto" data-id="element-5182" data-mp="2gnz0rqkppqv5">
                <li className="flex items-start" data-id="element-5183" data-mp="2glunwj4u5hiq">
                  <div className="w-5 h-5 rounded-full border border-gray-400 flex items-center justify-center mr-2 mt-0.5" data-id="element-5184" data-mp="51wucml05omn">
                    <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-5185" data-mp="7l9chcbl17"></div>
                  </div>
                  <span className="text-gray-600" data-id="element-5186" data-mp="3r8llai5hdp9e">
                    Full access to the networking event
                  </span>
                </li>
                <li className="flex items-start" data-id="element-5187" data-mp="nrwgp1pgkpmd">
                  <div className="w-5 h-5 rounded-full border border-gray-400 flex items-center justify-center mr-2 mt-0.5" data-id="element-5188" data-mp="nqlaywcgd7sm">
                    <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-5189" data-mp="e1jxpdxal4ic"></div>
                  </div>
                  <span className="text-gray-600" data-id="element-5190" data-mp="92grvr9hmu9b">Refreshments and dinner</span>
                </li>
                <li className="flex items-start" data-id="element-5191" data-mp="16hum1a1vg4mb">
                  <div className="w-5 h-5 rounded-full border border-gray-400 flex items-center justify-center mr-2 mt-0.5" data-id="element-5192" data-mp="16imi0lzds4d4">
                    <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-5193" data-mp="11p1igpi532bt"></div>
                  </div>
                  <span className="text-gray-600" data-id="element-5194" data-mp="a1gm7eiqs7kp">
                    Professional networking materials
                  </span>
                </li>
                <li className="flex items-start" data-id="element-5195" data-mp="13o648574vw9">
                  <div className="w-5 h-5 rounded-full border border-gray-400 flex items-center justify-center mr-2 mt-0.5" data-id="element-5196" data-mp="10s8kkx9g98c">
                    <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-5197" data-mp="trtqgtsc8ivk"></div>
                  </div>
                  <span className="text-gray-600" data-id="element-5198" data-mp="xsvstjhjxb1r">
                    Access to post-event connections
                  </span>
                </li>
              </ul>
              <Button className="w-full border-2 border-gray-800" data-id="element-5199" data-mp="jt4fzm2ru0pc">
                Register Now
              </Button>
            </div>
            <p className="text-gray-600" data-id="element-5200" data-mp="34jv88a7yql2x">
              Inner Circle members receive a special discount.
              <Link to="/membership" className="underline ml-1" data-id="element-5201" data-mp="39j7v2uyu3s5i">
                Learn more about membership
              </Link>
            </p>
          </div>
        </div>
      </section>
      {/* Location Map */}
      <section className="py-12" data-id="element-5202" data-mp="2x0vtihvg5hpw">
        <div className="container mx-auto px-4" data-id="element-5203" data-mp="2wzt288u7pd9g">
          <h2 className="text-2xl font-bold text-center text-gray-800 mb-8" data-id="element-5204" data-mp="3b0djv1oe531d">
            Event Location
          </h2>
          <div className="max-w-4xl mx-auto" data-id="element-5205" data-mp="361txx19srr90">
            <div className="aspect-[16/9] border-2 border-gray-300 rounded-lg overflow-hidden mb-6" data-id="element-5206" data-mp="35yy0de1v34l3">
              <div className="w-full h-full bg-gray-200 flex items-center justify-center" data-id="element-5207" data-mp="2i8ttmxtdmopv">
                <div className="text-center" data-id="element-5208" data-mp="2e7ru0fvjsand">
                  <MapPin size={48} className="text-gray-400 mx-auto mb-2" data-id="element-5209" data-mp="2s19go9jj63hm" />
                  <p className="text-gray-600" data-id="element-5210" data-mp="2naj86nft5kip">
                    Map of Deluxe á la Carte Restaurant, Warri
                  </p>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-5211" data-mp="1ullqalfidpqh">
              <div className="border-2 border-gray-300 rounded-lg p-6" data-id="element-5212" data-mp="1ulc1302afmlu">
                <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-5213" data-mp="r27fdiey2jg1">
                  Venue Details
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-5214" data-mp="m45uqt1vec2g">
                  <strong data-id="element-5215" data-mp="10rqvigb9vz77">Deluxe á la Carte Restaurant</strong>
                  <br data-id="element-5216" data-mp="10t22sq3xfp32" />
                  Warri, Delta State, Nigeria
                </p>
                <p className="text-gray-600" data-id="element-5217" data-mp="vyfnwcymzee8">
                  A premium dining venue with excellent facilities for
                  networking events. The restaurant offers a comfortable
                  atmosphere conducive to meaningful conversations and
                  connections.
                </p>
              </div>
              <div className="border-2 border-gray-300 rounded-lg p-6" data-id="element-5218" data-mp="1er9vgltxk48f">
                <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-5219" data-mp="1eoxhskv7gg16">
                  Contact Information
                </h3>
                <div className="space-y-4" data-id="element-5220" data-mp="3gin0davwec4h">
                  <p className="text-gray-600" data-id="element-5221" data-mp="3gjy2755s99sy">
                    <strong data-id="element-5222" data-mp="1w0m7z839ux9j">Event Coordinator:</strong>
                    <br data-id="element-5223" data-mp="1w14bmps9kdrh" />
                    The Networking Salon Team
                    <br data-id="element-5224" data-mp="20ydvzr0spz8g" />
                    info@thenetworkingsalon.live
                  </p>
                  <p className="text-gray-600" data-id="element-5225" data-mp="1m9hru51v16d4">
                    <strong data-id="element-5226" data-mp="1m8otnsgyvp6l">Local Lead:</strong>
                    <br data-id="element-5227" data-mp="1r8uh0wg7epiv" />
                    Warri City Ambassador
                    <br data-id="element-5228" data-mp="1d9urznos48m6" />
                    warri@thenetworkingsalon.live
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Final CTA */}
      <section className="py-16 bg-gray-50" data-id="element-5229" data-mp="13cgkweoqww6j">
        <div className="container mx-auto px-4 text-center" data-id="element-5230" data-mp="13dhvki1ungnq">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 max-w-2xl mx-auto" data-id="element-5231" data-mp="18bt6kw3vrx7j">
            Join Us in Warri to Build Connections That Matter
          </h2>
          <Button className="border-2 border-gray-800" data-id="element-5232" data-mp="32oss15uxzlmq">
            Register for the Event
            <ArrowRight size={16} className="ml-2" data-id="element-5233" data-mp="32mexqz836dg8" />
          </Button>
        </div>
      </section>
    </div>;
};